<template>
    <div class="tw-flex tw-flex-col tw-w-full">
        <h2 class="tw-normal-case tw-pb-2">About IATSE 667 and IATSE International</h2>

        <!--        About Us-->

        <div class="tw-flex tw-flex-col lg:tw-flex-row tw-text-xl tw-px-0 md:tw-px-6 tw-pt-6 tw-pb-6 tw-border-b tw-border-t tw-border-dark-grey">
            <div class="h7 tw-w-full tw-pt-2 lg:tw-pt-5 md:tw-w-1/6 pb-2">About Us</div>
            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-5/6 main-body-p">
                <div v-html="contents.about_us.body" class="admin-generated"></div>
                <a class="tw-flex tw-flex-row tw-items-center tw-gap-2" @click="$inertia.visit(route('how-to-join.index'))">
                    <action-arrow width="14"  />
                    <span class="tw-text-md sm:tw-text-xs tw-uppercase text-link">How to join</span>
                </a>
            </div>
        </div>
        <div class="tw-hidden sm:tw-flex tw-flex-col md:tw-flex-row tw-w-full tw-justify-between tw-py-3 tw-border-b tw-border-dark-grey">
            <div class="h7 tw-pt-2">History</div>
            <div class="tw-flex tw-flex-row tw-gap-10">
                <solid-black-arrows @click="historyGoPrev" :flip="true" />
                <solid-black-arrows @click="historyGoNext" />
            </div>

        </div>

        <!-- Mobile Menu -->
        <div class="tw-flex sm:tw-hidden tw-px-4 tw-pt-5 tw-pb-5 tw-flex-row tw-justify-between tw-items-center tw-border-b tw-border-dark-grey">
            <solid-black-arrows @click="historyGoPrev" :flip="true" />
            <h6 class="tw-text-xs tw-uppercase">History</h6>
            <solid-black-arrows @click="historyGoNext" />
        </div>
        <history-carousel
            ref="carousel_history"
            :items="history"
        />

        <!-- Board Members -->
        <div class="tw-border-t tw-border-dark-grey tw-flex tw-flex-col tw-text-xl tw-px-0 tw-pt-6 tw-pb-2 tw-border-b tw-border-dark-grey">
            <div class="h7">Our Board</div>
        </div>
        <div class="tw-flex tw-flex-col sm:tw-flex-row tw-justify-between tw-gap-4 lg:tw-gap-14 tw-mb-4 lg:tw-mb-12">
            <div class="tw-flex tw-flex-col tw-w-full sm:tw-w-3/6 tw-font-light">
                <div class="tw-text-xl lg:tw-text-3xl tw-uppercase tw-pt-4 tw-pb-2 tw-mb-6 tw-border-b tw-border-dark-grey">Executive Board Officers</div>
                <div v-for="board_member_title in board_member_titles" class="tw-pb-2">
                    <b>{{ board_member_title }}</b> /
                    <span v-for="(board_member, index) in board_members[board_member_title]" :key="index">
                        <span v-show="(index > 0)">, </span>
                        <a v-if="!!board_member.email" :href="`mailto:${board_member.email}`">{{ board_member.name }}
                          <v-icon
                              small
                          >
                              mdi-email
                            </v-icon>
                        </a>
                        <span v-else>{{ board_member.name }}</span>
                    </span>
                </div>
            </div>

            <div class="tw-flex tw-flex-col tw-w-full sm:tw-w-3/6 tw-font-light">
                <div class="tw-text-xl lg:tw-text-3xl tw-uppercase tw-pt-4 tw-pb-2 tw-mb-6 tw-border-b tw-border-dark-grey">Members At Large</div>
                <div v-for="member_at_large_title in member_at_large_titles" class="tw-pb-2">
                    <b>{{ member_at_large_title }}</b> /
                    <span v-for="(member_at_large, index) in members_at_large[member_at_large_title]" :key="index">
                        <span v-show="(index > 0)">, </span>
                        <a v-if="!!member_at_large.email" :href="`mailto:${member_at_large.email}`">
                            {{ member_at_large.name }}
                            <v-icon
                                small
                            >
                              mdi-email
                            </v-icon>
                        </a>
                        <span v-else>{{ member_at_large.name }}</span>

                    </span>
                </div>
            </div>
        </div>

        <!-- IATSE -->
        <div class="tw-border-t tw-border-dark-grey tw-pt-6">
            <div class="h7 pb-2 tw-border-b tw-border-dark-grey tw-pb-4">IATSE International</div>
            <div class="tw-flex tw-flex-col xl:tw-flex-row tw-w-full tw-gap-8 tw-py-7 tw-font-light about-us-link">
                <div class="tw-w-full xl:tw-w-3/6 tw-pr-0 xl:tw-pr-12 tw-text-justify">
                    <h3 class="tw-font-normal tw-pb-2">IATSE International</h3>
                    <p> The International Alliance of Theatrical Stage Employees, Moving Picture Technicians, Artists
                        and
                        Allied Crafts of the United States, Its Territories and Canada (IATSE) was founded in 1893 when
                        representatives of stagehands working in eleven cities met in New York and pledged to support
                        each
                        others’ efforts to establish fair wages and working conditions for their members.
                    </p>
                    <p> The first Canadian locals admitted were Montreal’s Local 56 and Toronto’s Local 58 and were
                        welcomed into the Alliance in 1898. Gaining admission to the National Alliance was difficult for
                        both groups due to concerns about internationalism and rapid expansion of the Alliance. However,
                        from the beginning, the Canadian locals were integrally involved in the Alliance and grew across
                        the
                        country.
                    </p>
                    <p> Today, we work in all forms of live theater, motion picture and television production, trade
                        shows
                        and exhibitions, television broadcasting, and concerts as well as the equipment and construction
                        shops that support all these areas of the entertainment industry.
                    </p>
                    <p> For more than a century, The IA have been the preeminent source of skilled labor for the motion
                        picture industry. IATSE members are union-trained in the latest technologies and safety
                        techniques;
                        productions in the United States, Canada and around the world have benefited from the passion,
                        skills and hard work of our crews.
                    </p>
                    <p> From the soft light falling on an actress’ face to the color and style of the gently fluttering
                        curtains in her living room during a summer rainstorm, the elements that help create beautiful
                        visual imagery and emotional moments are crafted by members of the IATSE Motion Picture
                        Division.
                    </p>
                    <p> On movies large and small, animated films and series, internet content, television shows across
                        the
                        dial – including children’s programming, reality, game, awards and talk shows – the list of our
                        job
                        requirements and skills is nearly endless. We build the sets, design the clothing, frame the
                        image,
                        record the dialogue, edit the scenes, animate the characters, and yes, even create weather to
                        help
                        bring a story to life.
                    </p></div>
                <div class="tw-grid md:tw-grid-cols-2 xl:tw-grid-cols-1 tw-gap-10 tw-text-justify tw-w-full xl:tw-w-3/6 ">
                    <div>
                        <h4 class="tw-font-normal tw-pb-2">Local Unions</h4>
                        <p> Within the U.S. and Canada, there are more than 360 Local Unions whose members make up the rank and
                            file of the IATSE. These Local Unions are organized by geographic region and craft jurisdictions,
                            which can be found at our <a href="https://iatse.net/local-union-directory/" target="_blank" class="text-link tw-text-blue-700">Local Union Directory</a>.
                        </p>
                        <p> Each local is an autonomous, independent entity. Each determines their own Constitution and
                            By-Laws, officer elections, dues structure, membership meetings, and more through democratic
                            processes.
                        </p>
                        <p> Locals negotiate labor contracts regarding wages, work rules, and grievance procedures. Some also
                            provide services to their members by administering health and retirement funds, and providing
                            training and education.
                        </p>
                    </div>
                    <div>
                        <h4 class="tw-font-normal tw-pb-2">IATSE International</h4>
                        The IATSE International supports the local unions and members by:
                        <ul class="tw-pb-2">
                            <li>Coordinating negotiation of nationwide agreements within the U.S. and Canada</li>
                            <li>Providing Local Unions with craft, safety, and leadership <a href="https://iatse.net/education/" target="_blank" class="text-link">education</a>.</li>
                            <li>Political and legislative <a href="https://iatse.net/political-legislative/" target="_blank" class="text-link">lobbying</a> for pro-worker policies.</li>
                            <li>Engaging directly in strategic organizing and collective bargaining campaigns.</li>
                        </ul>

                        <p>The International’s General Executive Board is led by the International President. It consists
                            of the General Secretary-Treasurer and 13 International Vice-Presidents. <a href="https://iatse.net/about/leadership/" target="_blank" class="text-link">Click here
                                to see our
                                current leadership.</a></p>
                        <p>The General Executive Board has the legislative authority to amend the International
                            Constitution by unanimous vote and the judicial authority to hear appeals from locals and
                            members from decisions of the International President.</p>
                        <p>All officers of the IATSE are elected during the IATSE International Convention, which is held
                            every four years.</p>
                    </div>
                    <div>
                        <h4 class="tw-font-normal tw-pb-2">Districts</h4>
                        <p>The IATSE Locals are subdivided into 13 geographical districts between the U.S. and Canada. Each
                            district has a designated secretary whose responsibility is to maintain records of the Districts
                            activities and finances, coordinate the District’s initiatives among the constituent locals, and
                            facilitate communication between the locals.</p>
                        <p>District Conventions are required to be held at least once every two years. Many Districts meet
                            annually. The District Conventions are for delegates of the affiliated locals to share common
                            interests, problems, and receive education and training. Resolutions and amendments to the
                            Constitution can originate in the District Conventions immediately preceding the International
                            Convention. Districts are also integral to coordinating the political and legislative activities
                            of their affiliated local unions.</p>
                    </div>
                </div>

            </div>
            <hr>
        </div>

        <!-- Categories -->
        <div class="tw-flex tw-flex-col md:tw-flex-row tw-text-xl tw-px-0 md:tw-px-6 tw-border-b tw-border-dark-grey tw-pt-6 tw-pb-2">
            <div class="h7">Member Categories</div>
        </div>
        <div class="tw-flex tw-flex-col tw-w-full main-body-p">
            <div
                v-for="(dept_name) in departments" :key="dept_name">
                <h3 class="tw-uppercase tw-ml-0 lg:tw-ml-56 tw-pb-4 tw-pt-4">{{dept_name}}</h3>
                <div class="tw-flex tw-flex-row tw-text-lg tw-font-light tw-pb-3 tw-w-full">
                    <div class="tw-ml-auto tw-w-full lg:tw-w-4/6">
                        <v-expansion-panels flat tile class="dense-panel">
                            <v-expansion-panel v-model="expanded_history_panels[dept_name]"
                                               v-for="(title, index) in title_functions[dept_name]" :key="index"
                                               class="bordered-header"
                                               dense
                            >
                                <v-expansion-panel-header hide-actions>

                                    <template v-slot:default="{ open }">

                                        <v-container class="py-0">
                                            <v-row no-gutters>
                                                <v-col cols="11">{{ title.display_name }}</v-col>
                                                <v-col cols="1">
                                                    <v-icon>
                                                        <template v-if="open">mdi-minus-circle</template>
                                                        <template v-else>mdi-plus-circle</template>
                                                    </v-icon>
                                                </v-col>
                                            </v-row>
                                        </v-container>

                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>{{ title.description }}</p>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import HistoryCarousel from "@/Pages/ExternalPages/components/HistoryCarousel.vue";
import ActionArrow from "@/Generic/icons/ActionArrow";
import SolidBlackArrows from "@/Generic/icons/SolidBlackArrows";

export default {
    name: "AboutUsIndex",
    components: {
        HistoryCarousel,
        ActionArrow,
        SolidBlackArrows
    },

    layout: (h, page) => {
        return h(AppLayout, [
            page
        ])
    },
    props: {
        'history': {
            type: Array,
            required: false,
            default: function () {
                return undefined
            }
        },
        'title_functions': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'board_members': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'members_at_large': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'contents': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
    },
    data() {
        return {
            expanded_history_panels: [],
        }
    },

    computed: {
        departments() {
            return Object.keys(this.title_functions)
        },
        board_member_titles() {
            return Object.keys(this.board_members)
        },
        member_at_large_titles() {
            return Object.keys(this.members_at_large)
        },
    },

    methods: {
        getImagePath(image) {
            return `/storage/contents/${image}`;
        },
        historyGoPrev() {
            this.$refs.carousel_history.goPrev()
        },
        historyGoNext() {
            this.$refs.carousel_history.goNext()
        },
    },
}
</script>
<style scoped>
ol li::marker {
    font-weight: 400;
}
li {
    font-weight: 300;
}
.bordered-header {
    border-top-width: 1px;
    border-color: #4c4c4c;
}
.dense-panel button.v-expansion-panel-header {
    padding: 0 !important;
}
admin-generated >>> hr {
    margin-top: 15px !important;
    margin-bottom: 15px !important;
}
.about-us-link a {
    color: #1d4ed8 !important;
}
.about-us-link a:hover {
    color: white !important;
}
.aspect-ratio {
    position: relative;
    width: 100%;
}

.aspect-ratio::before {
    content: "";
    padding-top: 100%; /* This creates a 1:1 aspect ratio (square). You can adjust this percentage to change the aspect ratio. */
    display: block;
}

.aspect-ratio img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain; /* Keeps the aspect ratio and ensures the whole image fits inside the container without cropping. */
}


</style>
